import React, {useEffect, useState, useRef} from "react";
import env from "../../../env";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Email, Lock} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import moment from 'moment';
import Grid from '@material-ui/core/Grid/Grid';
import Person from "@material-ui/icons/Person";
import Phone from "@material-ui/icons/Phone";
import Ticket from "@material-ui/icons/ConfirmationNumber";
import LocationCity from "@material-ui/icons/LocationCity";
import Group from "@material-ui/icons/Group";
import usStates from '../../../utilities/us-states';
import GenericField from "../../../components/Forms/GenericField";
import { AsyncSelect } from "../../../components/Forms/Select";
import PhoneNumberField from "../../../components/Forms/PhoneNumberField";
import Button from "@material-ui/core/Button";
import ReCAPTCHA from "react-google-recaptcha";
import {useDispatch, useSelector} from "react-redux";
import userAction from "../../../actions/user.action";
import ErrorMessage from "../../../components/UI/ErrorMessage";
import DateDropdownGroup from "../../../components/Forms/DateDropdownGroup";


const RegistrationForm = ({bdList, bdListUnverified, debouncedFetch, signingUp, classes}) => {
  const recaptchaRef = useRef();
  const [form, setForm] = useState({
    email: '',
    password: '',
    confirm_password: '',
    streetAddress: '',
    first_name: '',
    last_name: '',
    phone: '',
    city: '',
    state: '',
    bdAffiliation: '',
    bdRepCode: '',
    advisorCrdRef: '',
    birthdate: '',
  });
  const [isOtherBDSelected, setIsOtherBDSelected] = useState(false);
  const [emailAllowed, setEmailAllowed] = useState(false);
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
  const [passwordNotMatched, setPasswordNotMatched] = useState(false);
  const [isDoBValid, setIsDoBValid] = useState(true);
  const dispatch = useDispatch();
  const userState = useSelector(store => store.user);
  const appState = useSelector(state => state.app);


  useEffect(() => {
    // Reset recaptcha in case any error from the server
    if (userState.message) {
      recaptchaRef.current.reset();
    }
  }, [userState.message]);

  useEffect(() => {
    setPasswordNotMatched(form.password.length > 0 && form.confirm_password.length > 0 && form.password !== form.confirm_password);
  }, [form.password, form.confirm_password]);

  const handleChange = e => {
    if (e.constructor.name === 'SyntheticEvent') {
      e.preventDefault();
    }
    let { name, value } = e.target;
    if (name === 'bdRepCode') {
      value = value.toUpperCase();
    }
    setForm({...form, [name]: value });
  };

  const handleBDAffiliationChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    if (value === 'Other'){
      setIsOtherBDSelected(true);
      setForm({...form, [name]: ''});
    }
    else {
      setIsOtherBDSelected(false);
      setForm({...form, [name]: value});
    }
  };

  const checkWhiteList = () => {
    const whiteList = [
      /@wbiinvestments.com\s*$/,
      /@hartshorne.com\s*$/,
      /investwithcy.com\s*$/,
    ];
    if (form.email.length) {
      const test = whiteList.find(domain => domain.test(form.email.toLowerCase()))
      setEmailAllowed(!!test)
    }
  };

  const onSubmitWithReCaptcha = async (e) => {
    e.preventDefault();
    if (passwordNotMatched) return;
    const token = await recaptchaRef.current.executeAsync();
    dispatch(userAction.signUp({...form, captcha: token}));
  };

  const asyncScriptOnLoad = () => {
    setRecaptchaLoaded(true);
  };

  return (
    <div className={`${classes.form} ${classes.signupForm}`}>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={env.REACT_APP_RECAPTCHA_SITE_KEY}
        asyncScriptOnLoad={asyncScriptOnLoad}
      />
      {!userState.loggedIn && userState.message && (
        <ErrorMessage>{userState.message}</ErrorMessage>
      )}
      {passwordNotMatched && (
        <ErrorMessage>Password does not match!</ErrorMessage>
      )}
      <div className={classes.mobileLeftCol}>
        <TextField
          label="Email Address"
          name="email"
          type="email"
          onChange={handleChange}
          onBlur={checkWhiteList}
          margin="normal"
          required
          fullWidth
          value={form.email}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email />
              </InputAdornment>
            ),
          }}
        />
        {
        appState.demoMode &&
        !emailAllowed && (
          <Typography color={"error"}>
            This email domain is not allowed.
          </Typography>
        )}
        <TextField
          label="Password"
          name="password"
          type="password"
          onChange={handleChange}
          margin="normal"
          required
          fullWidth
          value={form.password}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Lock />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Confirm Password"
          name="confirm_password"
          type="password"
          onChange={handleChange}
          margin="normal"
          value={form.confirm_password}
          required
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Lock />
              </InputAdornment>
            ),
          }}
        />
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <TextField
              label="First Name"
              name="first_name"
              type="text"
              onChange={handleChange}
              margin="normal"
              value={form.first_name}
              required
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Last Name"
              name="last_name"
              type="text"
              onChange={handleChange}
              margin="normal"
              value={form.last_name}
              required
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <PhoneNumberField
          label="Phone Number"
          name="phone"
          type="text"
          onChange={handleChange}
          margin="normal"
          value={form.phone}
          required
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Phone />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Address"
          name="streetAddress"
          type="text"
          onChange={handleChange}
          margin="normal"
          required
          value={form.streetAddress}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCity />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="City"
          name="city"
          type="text"
          onChange={handleChange}
          margin="normal"
          required
          value={form.city}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCity />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="State"
          name="state"
          select
          value={form.state}
          onChange={handleChange}
          margin="normal"
          required
          fullWidth
          SelectProps={{
            native: true,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCity />
              </InputAdornment>
            ),
          }}
        >
          <option key='' value=''/>
          {Object.keys(usStates).map((stateAbbr) => (
            <option key={stateAbbr} value={stateAbbr}>
              {usStates[stateAbbr]}
            </option>
          ))}
        </TextField>
        <TextField
          fullWidth
          margin="normal"
          label="BD/RIA Affiliation (Company you receive compensation through)"
          name="bdAffiliation"
          required
          select
          value={isOtherBDSelected ? 'Other' : form.bdAffiliation}
          onChange={handleBDAffiliationChange}
          SelectProps={{
            native: true,
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">
              <Group />
            </InputAdornment>
          }}
        >
          <option key='' value=''/>
          {
            [
              ...bdList,
              ...(
                bdListUnverified.length > 0 ?
                  [{ name: "Other" }] :
                  []
              )
            ].map((bd) => (
              <option key={bd.name} value={bd.name}>
                {bd.name}
              </option>
            ))
          }
        </TextField>
        {isOtherBDSelected &&
        <Grid container spacing={1}>
          <Grid item xs={2} md={1}>

          </Grid>
          <Grid item xs={10} md={11}>
            <GenericField
              fullWidth
              margin="none"
              required
              onChange={(option) =>
                setForm({...form, bdAffiliation: option ? option.value : null })
              }
              style={{marginTop:"-10px"}}
              inputComponent={AsyncSelect}
              inputProps={{
                loadOptions: debouncedFetch,
                placeholder: "Type to search...",
                isClearable: true,
                value: {label: form.bdAffiliation, value: form.bdAffiliation},
                noOptionsMessage: () => ('Type to search...'),
                ref: 'bdAffiliation'
              }}
            />
          </Grid>
        </Grid>
        }
        <TextField
          label="BD Rep Code"
          name="bdRepCode"
          type="text"
          onChange={handleChange}
          value={form.bdRepCode}
          margin="normal"
          fullWidth
          required
          InputProps={{
            autoComplete: 'bd-rep-code',
            startAdornment: (
              <InputAdornment position="start">
                <Group />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Advisor CRD Reference"
          name="advisorCrdRef"
          type="number"
          onChange={handleChange}
          margin="normal"
          fullWidth
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Ticket />
              </InputAdornment>
            ),
          }}
        />
        <DateDropdownGroup
          label="Date of birth"
          onChange={(v) => {
            setIsDoBValid(moment(v, "YYYY-MM-DD", true).isValid())
            setForm({
              ...form,
              birthdate: v,
            })}
          }
          isValid={isDoBValid}
          required
        />
      </div>
      <div className={classes.mobileRightCol}>
        <div className={classes.mobileRightCol}>
          <Button
            fullWidth
            disabled={
                (appState.demoMode && !emailAllowed) ||
                signingUp ||
                passwordNotMatched ||
                !recaptchaLoaded ||
                !isDoBValid ||
                  Object.values(form).some(el => el === '')
            }
            variant="contained"
            color="secondary"
            className={classes.ctaSignup}
            onClick={onSubmitWithReCaptcha}
          >
            Sign Up
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/containers/Login/components/RegistrationForm.jsx